import { DsPaperDefaultProps } from './DsPaper.Types';
export const DsPaperOverrides = {
    MuiPaper: {
        defaultProps: DsPaperDefaultProps,
        styleOverrides: {}
    }
};
